import { ILegalTransactionRelationship } from '../../../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationship';
import { ILegalTransactionRelationshipMember } from '../../../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationshipMember';
import { LegalTransactionRelationshipTypeEnum } from '../../../../Interfaces/ILegalTransactionRelationship/LegalTransactionRelationshipTypeEnum';
import { IMemberSigner } from '../../../../Interfaces/ILegalTransactionRelationship/Members/IMemberSigner';
import {
  getEmptySignatureCertificationRelationship,
  ISignatureCertificationRelationship,
} from '../../../../Interfaces/ILegalTransactionRelationship/Relationships/SignatureCertification/ILegalTransactionRelationshipSignatureCertification';

export const SIGNATURE_CERTIFICATION_RELATIONSHIP_MEMBER_ROLE_ID = 20;

export function isSignatureCertificationRelationship(
  relationship: ILegalTransactionRelationship
): relationship is ISignatureCertificationRelationship {
  return (
    relationship.idRelationshipType ===
    LegalTransactionRelationshipTypeEnum.SignatureCertification
  );
}

export const getExistingSignatureCertificationRelationship = (
  relationships: ILegalTransactionRelationship[]
): ISignatureCertificationRelationship | undefined => {
  return relationships.find(isSignatureCertificationRelationship);
};

export const getOrCreateSignatureCertificationRelationship = (
  relationships: ILegalTransactionRelationship[]
): ISignatureCertificationRelationship => {
  const existingRelationship =
    getExistingSignatureCertificationRelationship(relationships);

  if (existingRelationship) {
    return existingRelationship;
  }

  return getEmptySignatureCertificationRelationship();
};

export const isSignatureCertificationMember = (
  member: ILegalTransactionRelationshipMember | undefined
): member is IMemberSigner => {
  return (
    !!member &&
    member.idRelationshipRole ===
      SIGNATURE_CERTIFICATION_RELATIONSHIP_MEMBER_ROLE_ID
  );
};
